<button
  class="timeline-layer-volume"
  (wheel)="onWheel($event)"
  (keydown)="onKeyDown($event)"
  #buttonElement
  title="Change the volume of the layer"
  i18n-title
>
  <span
    class="timeline-layer-volume__icon"
    (click)="onIconClick()"
    #iconElement
  >
    <span class="icon-volume-high" *ngIf="volumeIsHigh"></span>
    <span class="icon-volume-medium" *ngIf="volumeIsMedium"></span>
    <span class="icon-volume-low" *ngIf="volumeIsLow"></span>
    <span class="icon-volume-mute" *ngIf="volumeIsMuted"></span>
  </span>

  <span
    class="timeline-layer-volume-slider"
    #sliderElement
    appHorizontalDrag
    (onHorizontalDragStart)="onHorizontalDragStart($event)"
    (onHorizontalDrag)="onHorizontalDrag($event)"
  >
    <span class="timeline-layer-volume-slider-track" #trackElement>
      <span
        class="timeline-layer-volume-slider-track__handle"
        [style.left.%]="sliderHandlePosition"
      ></span>
    </span>
  </span>
</button>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-volume/timeline-layer-volume.component.html